module.exports = __webpack_public_path__ + "static/cerro_negro-2c98ab57ef54371058b619163d2e3343.jpg";